export default "__VITE_ASSET__DDlq5fe5__"